module.exports = __webpack_public_path__ + "static/img/baojiadna.bc8fe8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/baojiadna.png
// module id = M4/Z
// module chunks = 1